import { useQuery } from "@apollo/client";
import { getSubjectStandardSetDetailsQuery } from "../modules/Queries";
import { useMemo } from "react";
import { useReduxState } from "SubjectStandardsV2/hooks/useReduxState";
import { getCurriculumIdAndType } from "SubjectStandardsV2/modules/reduxSelectors";
import _ from "lodash";

const useSubjectSet = params => {
  const { parentNodeId, showCourseStandards, learningCourseId } = params;
  const { isPYPCurriculum } = useReduxState(getCurriculumIdAndType);

  const { data, loading } = useQuery(getSubjectStandardSetDetailsQuery, {
    fetchPolicy: "cache-and-network",
    variables: {
      id: parentNodeId,
      learningCourseIds: learningCourseId ? [learningCourseId] : [],
    },
    skip: !parentNodeId,
  });

  const standardEdges = useMemo(() => {
    const plannerElementNodeSet = data?.node?.plannerElementNodeSet;

    const title =
      plannerElementNodeSet?.title ||
      plannerElementNodeSet?.subject?.name ||
      "";

    const allStandardsCount = _.get(
      plannerElementNodeSet,
      "plannerElementNodeSetWrapperV2.publishedData.totalCount",
      0
    );

    const courseStandardsCount = isPYPCurriculum
      ? _.size(plannerElementNodeSet?.courseBenchmarkStandards || [])
      : _.size(plannerElementNodeSet?.courseStandards || []);

    return [
      {
        standardSet: {
          ..._.omit(plannerElementNodeSet, "plannerElementNodeSetWrapperV2"),
          title,
          totalCount: showCourseStandards
            ? courseStandardsCount
            : allStandardsCount,
        },
      },
    ];
  }, [data, isPYPCurriculum, showCourseStandards]);

  const idsToPropertiesMap = useMemo(() => {
    return _.reduce(
      standardEdges,
      (acc, edge) => {
        const { standardSet = {} } = edge || {};

        acc[standardSet.id] = standardSet;
        return acc;
      },
      {}
    );
  }, [standardEdges]);

  return {
    showLoader: _.isEmpty(data) && loading,
    idsToPropertiesMap,
    standardEdges,
  };
};

export default useSubjectSet;
